// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import StarFilledSvg from "@ant-design/icons-svg/lib/asn/StarFilled";
import AntdIcon from "../components/AntdIcon";
const StarFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: StarFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    StarFilled.displayName = "StarFilled";
}
export default /*#__PURE__*/ React.forwardRef(StarFilled);
